import { formatPrice } from '@/services/formatter';
import { checkIsValidJSON } from '@/services/helpers/checkIsValidJSON';

import type { ISapaAdditionalProducts } from '../types/sapa.types';

export const parseSapaAdditionalProducts = (responseApprovedBody: string) => {
  const isValidJSON = checkIsValidJSON(responseApprovedBody);
  if (!isValidJSON) return [];
  const parsedJSON = JSON.parse(
    responseApprovedBody
  ) as ISapaAdditionalProducts;

  const additionalProducts: string[] = [];

  if (parsedJSON.insuranceKaskoAmount)
    additionalProducts.push(
      [
        'КАСКО',
        `${formatPrice(parsedJSON.insuranceKaskoAmount)} ₸`,
        parsedJSON.term ? `${parsedJSON.term} м.` : undefined
      ]
        .filter(Boolean)
        .join(' | ')
    );
  if (parsedJSON.insuranceLifeAmount)
    additionalProducts.push(
      `Сумма страхования жизни ${formatPrice(parsedJSON.insuranceLifeAmount)} ₸`
    );
  if (parsedJSON.creditHolidayAmount)
    additionalProducts.push(
      `Кредитный отпуск ${formatPrice(parsedJSON.creditHolidayAmount)} ₸`
    );
  if (parsedJSON.carCheckAmount)
    additionalProducts.push(
      `Автотехцентр ${formatPrice(parsedJSON.carCheckAmount)} ₸`
    );
  if (parsedJSON.registratorAmount)
    additionalProducts.push(
      `Сумма регистратора ${formatPrice(parsedJSON.registratorAmount)} ₸`
    );

  return additionalProducts;
};
